import { toJS, makeAutoObservable } from 'mobx';
import {v4 as uuidv4} from 'uuid';
import _ from 'lodash';

class AvailabilityWindowsTableState {
  windows = [];

  constructor() {
    makeAutoObservable(this);
  }

  receiveProps({windows, onChange}) {
    this.windows = windows;
    this.onChange = onChange;
  }

  get sortedWindows() {
    return _.sortBy(this.windows, ['dayOfWeek']);
  }

  updateAvailabilityWindow(window, patch) {
    Object.assign(window, patch);
    this.onChange(toJS(this.windows));
  }

  addAvailabilityWindow(dayOfWeek) {
    this.windows.push({id: uuidv4(), dayOfWeek, startTimeString: '', endTimeString: ''});
    this.onChange(toJS(this.windows));
  }

  removeAvailabilityWindow(window) {
    const rowsForDay = this.windows.filter(w => w.dayOfWeek === window.dayOfWeek);

    if (rowsForDay.length > 1) {
      this.windows.remove(window);
    } else {
      Object.assign(window, {id: uuidv4(), startTimeString: '', endTimeString: ''});
    }

    this.onChange(toJS(this.windows));
  }
}

export default AvailabilityWindowsTableState;
